import client from "@/api/client"
import { CreateComfyUIRecipeTaskDto } from "@/api/sdk"
import { createMutation } from "react-query-kit"

export const useAddTaskMutation = createMutation({
  mutationFn: async (params: CreateComfyUIRecipeTaskDto) => {
    return client.api.sdWorkflowControllerAddTask(params).then(res => res.data)
  },
})
